import { useMutation } from "@tanstack/react-query";
import { ApiEstimateOrderFees } from "@/api";
import type {
  EstimateOrderFeesRequest,
  EstimateOrderFeesResponse,
} from "@/api/types";

/**
 * 预估下单手续费（/game/cex/EstimateOrderFees）
 *
 * 说明：
 * - 入参 `strategyId` 应使用 GetSignal 返回的 `id`
 * - 入参 `leverage` 使用用户最终确认下单的杠杆
 */
export function useEstimateOrderFees() {
  return useMutation({
    mutationFn: async (
      data: EstimateOrderFeesRequest
    ): Promise<EstimateOrderFeesResponse> => {
      console.log("useEstimateOrderFees", data);
      const res = await ApiEstimateOrderFees(data);
      console.log("useEstimateOrderFees", res.data);
      return res.data;
    },
  });
}
